import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  concentratorsError: {},
  concentratorSelectedError: {},
  agencieSelectedError: {},
  termsAndConditionError: { trys: 0 },
  my_agenciesError: {},
  usersError: {},
  gamesError: {},
  providersError: {},
  configError: {},
  logosError: {},
  rafflesError: {},
  deliveryError: {},
  couponsError: {},
};

const errorsSlice = createSlice({
  name: "errors",
  initialState,
  reducers: {
    setConcentratorsError(state, action) {
      state.concentratorsError = {
        error: action.payload.error,
        code: action.payload.code,
      };
    },
    setConcentratorSelectedError(state, action) {
      state.concentratorSelectedError = {
        error: action.payload.error,
        code: action.payload.code,
      };
    },
    setAgencieSelectedError(state, action) {
      state.agencieSelectedError = {
        error: action.payload.error,
        code: action.payload.code,
      };
    },
    setTermsAndConditionError(state, action) {
      state.termsAndConditionError = {
        error: action.payload.error,
        code: action.payload.code,
        trys: action.payload.trys ? state.termsAndConditionError.trys + 1 : 0,
      };
    },
    setMy_AgenciesError(state, action) {
      state.my_agenciesError = {
        error: action.payload.error,
        code: action.payload.code,
      };
    },
    setUsersError(state, action) {
      state.usersError = {
        error: action.payload.error,
        code: action.payload.code,
      };
    },
    setGamesErrors(state, action) {
      state.gamesError = {
        error: action.payload.error,
        code: action.payload.code,
      };
    },
    setConfigErrors(state, action) {
      state.configError = {
        error: action.payload.error,
        code: action.payload.code,
      };
    },
    setLogosErrors(state, action) {
      state.logosError = {
        error: action.payload.error,
        code: action.payload.code,
      };
    },
    setRafflesErrors(state, action) {
      state.rafflesError = {
        error: action.payload.error,
        code: action.payload.code,
      };
    },
    setProvidersErrors(state, action) {
      state.providersError = {
        error: action.payload.error,
        code: action.payload.code,
      };
    },
    setDeliveryErrors(state, action) {
      state.deliveryError = {
        error: action.payload.error,
        code: action.payload.code,
      };
    },
    setCouponsErrors(state, action) {
      state.couponsError = {
        error: action.payload.error,
        code: action.payload.code,
      };
    },
    resetErrors(state, action) {
      state.concentratorsError = {};
      state.concentratorSelectedError = {};
      state.agencieSelectedError = {};
      state.termsAndConditionError = { trys: 0 };
      state.my_agenciesError = {};
      state.usersError = {};
      state.gamesError = {};
      state.providersError = {};
      state.configError = {};
      state.logosError = {};
      state.rafflesError = {};
      state.deliveryError = {};
      state.couponsError = {};
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setConcentratorsError,
  setConcentratorSelectedError,
  setAgencieSelectedError,
  setRafflesErrors,
  resetErrors,
  setCouponsErrors,
  setTermsAndConditionError,
  setMy_AgenciesError,
  setUsersError,
  setGamesErrors,
  setConfigErrors,
  setDeliveryErrors,
  setLogosErrors,
  setProvidersErrors,
} = errorsSlice.actions;
export default errorsSlice.reducer;
